require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-how-can-the-world-bank-play-an-active-role-in-addressing.json") })
        }
      }, "path---en-us-update-how-can-the-world-bank-play-an-active-role-in-addressing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-how-can-the-world-bank-play-an-active-role-in-addressing!./.cache/json/en-us-update-how-can-the-world-bank-play-an-active-role-in-addressing.json
// module id = 719
// module chunks = 231608221292675